export const videos = [
    {
        src: "https://www.youtube.com/embed/AoJS6zfd0g0"
    },{
        src: "https://www.youtube.com/embed/6rB5dxNxjhM"
    }
]